import { useEffect, useMemo, useState } from "react";
import { VoiceMachine, VoiceMachineDeps } from "./machine";
import { VoiceCriteria, VoiceState } from "./types";

/**
 * React hook wrapping machine.ts. Imports 'react' only — never react-dom —
 * so it can be reused verbatim from a React Native screen once that ships.
 */
export function useVoiceSearch(deps: VoiceMachineDeps) {
  const machine = useMemo(() => new VoiceMachine(deps), [deps]);
  const [state, setState] = useState<VoiceState>(machine.getState());

  useEffect(() => machine.subscribe(setState), [machine]);

  return {
    state,
    start: () => machine.start(),
    stop: () => machine.stop(),
    cancel: () => machine.cancel(),
    confirmTranscript: (text?: string) => machine.confirmTranscript(text),
    discardTranscript: () => machine.discardTranscript(),
    discardReview: () => machine.discardReview(),
    resolveAmbiguity: (selections: Partial<Record<keyof VoiceCriteria, string>>) =>
      machine.resolveAmbiguity(selections),
    reset: () => machine.reset(),
  };
}
